/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { View } from 'react-native';
import InputStepperView from '@airasia-phoenix/react-native/components/InputStepperView';
import { getTextStyle, pd } from '@airasia-phoenix/react-native/utils/utils';
import { PassengerItemProps } from './types';
import { StyleSheet } from 'react-native-unistyles';
import TextView from '@airasia-phoenix/react-native/components/TextView';

const PassengerItem = (props: PassengerItemProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <TextView
          text={props.primaryText}
          style={getTextStyle(
            pd.sys.typescale.body_text_medium,
            pd.sys.colour.content_primary,
          )}
        />
        <TextView
          text={props.secondaryText}
          style={getTextStyle(
            pd.sys.typescale.caption_text,
            pd.sys.colour.content_secondary,
          )}
        />
      </View>
      <View style={{ top: 0 }}>
        <InputStepperView {...props.inputStepperProps} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textContainer: { flexDirection: 'column', width: '55%' },
});

export default PassengerItem;
